import { useState, useCallback } from "react";
import Cookies from "js-cookie";
import { useTrainingProgramQuery } from "./useTrainingProgramQuery";
import { useAPI } from "./useAPI";

export function useAuthData(apiBaseUrl, enabled = true, authToken) {
  const currentPath = window.location.pathname.toLowerCase();
  const is2FA = currentPath.includes("2fa");
  // const authToken = Cookies.get("token")
  // Only enable the query if we actually have a token
  const canFetch = enabled && !!authToken && !is2FA;

  const {
    data: trainingProgramsData,
    isLoading: isLoadingPrograms,
    error: programsError,
  } = useTrainingProgramQuery(apiBaseUrl, authToken, canFetch);

  // 2. Derive these values instead of using useEffect
  const allTrainingPrograms = trainingProgramsData || null;
  const trainingProgram = (Array.isArray(trainingProgramsData) && trainingProgramsData.length > 0) 
    ? trainingProgramsData[0] 
    : null;

  return {
    trainingProgram, // Now updates instantly when React Query data arrives
    allTrainingPrograms,
    isLoading: isLoadingPrograms // Useful to show a spinner
  };
}
